import { useReducer } from "react";
import useToggle from "../../../hook/useToggle";
import { Action } from "../../../types/reducer-action";
import AccordionContainer from "../../common/accordion-container";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import { AddIcon } from "../../common/icons";
import NewPositionModal from "./new-position-modal";
import PositionDetailsPane from "./position-details-pane";
import { PositionTitleContext, PositionTitleDispatchContext, PositionTitleState, positionTitleReducer, usePositionTitleDispatch } from "./position-manager-context";
import PositionTitleResultsTable from "./position-title-results-table";
import PositionTitleSearchForm from "./position-title-search-form";
import Button from "../../common/button";
import confirm from "../../common/confirm";

function showDuplicateConfirmation(): void {
  confirm({
    title: 'Duplicated position/role',
    content: 'There is already a position/role with the same title in OMS. You cannot duplicate the position/role title.',
    okText: '', // hide OK button
    cancelText: 'OK',
    titleCenter: true,
    bodyCenter: true
  });
}

export function PositionManager() {
  const [state, dispatch] = useReducer(positionTitleReducer, {} as PositionTitleState)

  return (
    <PositionTitleContext.Provider value={state}>
      <PositionTitleDispatchContext.Provider value={dispatch}>
        <PositionTitleActionPane />

        <PositionTitleSearchPane />

        <PositionDetailsPane showDuplicateConfirmation={showDuplicateConfirmation} />
      </PositionTitleDispatchContext.Provider>
    </PositionTitleContext.Provider>
  )
}

function PositionTitleActionPane() {
  const dispatch = usePositionTitleDispatch();

  const { isOpen: isCreationModalOpen, toggle: toggleCreationModal } = useToggle();

  const handleNew = () => {
    dispatch(new Action(DataEntryEvent.NewForm));
    toggleCreationModal();
  };

  return (
    <div>
      <Button type="button" color="primary" className="action-link"
        onClick={handleNew} >
        <AddIcon /> Create New Position/Role
      </Button>

      <NewPositionModal isOpen={isCreationModalOpen} toggle={toggleCreationModal} showDuplicateConfirmation={showDuplicateConfirmation} />
    </div>
  )
};

function PositionTitleSearchPane() {
  return (
    <AccordionContainer title="Search Position/Role">
      <PositionTitleSearchForm />
      <PositionTitleResultsTable pageSize={10} />
    </AccordionContainer>
  )
}
